var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ALERTS_DATA_INITIALIZE, ALERTS_DATA_RESET, ALERTS_DATA_SET_ERROR, ALERTS_DATA_SET_HAS_ACKNOWLEDGE_TERMS_CONDITIONS, ALERTS_DATA_SET_IS_LOADED, ALERTS_DATA_SET_IS_TERMS_CONSENT_DATA_LOADING, ALERTS_DATA_SET_SHOW_TERMS_CONSENT_BANNER, ALERTS_DATA_SET_TERMS_CONSENT_ERROR, ALERTS_DATA_UPDATE_ALERT } from '../actionTypes';
export var initialState = {
    byId: {},
    allIds: [],
    error: '',
    isLoaded: false,
    hasAcknowledgeTermsConditions: false,
    showTermsConsentBanner: false,
    termsConsentError: '',
    isTermsConsentDataLoading: false
};
var alertsData = function (
// eslint-disable-next-line default-param-last
state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    var payload = action === null || action === void 0 ? void 0 : action.payload;
    var id = payload === null || payload === void 0 ? void 0 : payload.id;
    var currentAlertData = state.byId[id];
    switch (action.type) {
        case ALERTS_DATA_INITIALIZE: {
            var hasChangeableDeliveryMethods = payload.allDeliveryMethods.some(function (delMeth) { return delMeth.changeable; });
            var hasChangeableAttributes = payload.attributes.some(function (attr) { return attr.changeable; });
            return __assign(__assign({}, state), { allIds: __spreadArray(__spreadArray([], state.allIds, true), [id], false), byId: __assign(__assign({}, state.byId), (_a = {}, _a[id] = {
                    id: id,
                    allDeliveryMethods: payload.allDeliveryMethods,
                    attributes: payload.attributes,
                    categoryId: payload.categoryId,
                    isAlertOn: payload.isAlertOn,
                    hasChangeableDeliveryMethods: hasChangeableDeliveryMethods,
                    hasChangeableAttributes: hasChangeableAttributes,
                    hasChangeableData: hasChangeableDeliveryMethods || hasChangeableAttributes
                }, _a)) });
        }
        case ALERTS_DATA_UPDATE_ALERT: {
            return __assign(__assign({}, state), { byId: __assign(__assign({}, state.byId), (_b = {}, _b[id] = __assign(__assign({}, currentAlertData), { allDeliveryMethods: payload.allDeliveryMethods, attributes: payload.attributes, isAlertOn: payload.isAlertOn }), _b)) });
        }
        case ALERTS_DATA_SET_IS_LOADED: {
            return __assign(__assign({}, state), { isLoaded: payload.isLoaded });
        }
        case ALERTS_DATA_SET_ERROR: {
            return __assign(__assign({}, state), { error: payload.error });
        }
        case ALERTS_DATA_SET_HAS_ACKNOWLEDGE_TERMS_CONDITIONS: {
            return __assign(__assign({}, state), { hasAcknowledgeTermsConditions: payload.hasAcknowledgeTermsConditions });
        }
        case ALERTS_DATA_SET_SHOW_TERMS_CONSENT_BANNER: {
            return __assign(__assign({}, state), { showTermsConsentBanner: payload.showTermsConsentBanner });
        }
        case ALERTS_DATA_SET_IS_TERMS_CONSENT_DATA_LOADING: {
            return __assign(__assign({}, state), { isTermsConsentDataLoading: payload.isTermsConsentDataLoading });
        }
        case ALERTS_DATA_SET_TERMS_CONSENT_ERROR: {
            return __assign(__assign({}, state), { termsConsentError: payload.termsConsentError });
        }
        case ALERTS_DATA_RESET: {
            return __assign({}, initialState);
        }
        default:
            return state;
    }
};
export default alertsData;
